import React from "react";
const Error = (props) => {
    const classes = `align-self-center mb-2 text-danger fs-md fw-medium${props.className ? ' ' + props.className : ''}`;
    return (
        <p className={classes}>
            {props.children}
        </p>
    )
}
export default Error;
